/**
 * Display a message + user avatar in profile popin.
 * Accessible from new inbox when clicking user avatar on a task, or from PP via "see profile" button
 */
avatarAndBubble.$inject = ['$filter', 'MediasFactory'];
export function avatarAndBubble($filter, MediasFactory) {
  return {
    restrict: 'E',
    template: require('./avatar-and-bubble.directive.html'),
    scope: {
      companyId: '<',
      siteId: '<',      
      message: '<',
      openedFromTaskId: '<',
      scrollToOtherMessage: '&' 
    },
    link: link
  };

  function link($scope, element) {
  
    $scope.openInModal = openInModal;
    $scope.downloadAttachment = downloadAttachment;

    init();

    function init() {
      $scope.model = $filter('message2AvatarAndBubble')($scope.message, $scope.openedFromTaskId);
      $scope.$watch('message.dayIndicator', dayIndicator => $scope.model.dayIndicator = dayIndicator);
      $scope.$watch('message.skipAvatar', skipAvatar => $scope.model.skipAvatar = skipAvatar);
      $scope.$watch('message.smallerBottomMargin', smallerBottomMargin => $scope.model.smallerBottomMargin = smallerBottomMargin);
    }

    function openInModal(imgSrc){
      MediasFactory.pictureZoomMaterial(imgSrc, 'picture');
    }

    function downloadAttachment(attachment) {
      MediasFactory.downloadFile(attachment.url, attachment.name);
    }
  }
}

